export const DatePickerDefaults = {
	dateFormat: 'DD.MM.YYYY',
	dateTimeFormat: 'DD.MM.YYYY HH:mm ',
	timeFormat: 'HH:mm ',
	locale: 'ru',
}
